import { BnAction } from '../../common/bn-action';

class BinLevelDateRange extends BnAction {
  constructor() {
    super();
    this.actionname = 'custom-date-range';
  }
}

window.customElements.define('bin-level-daterange', BinLevelDateRange);
